import { render, staticRenderFns } from "./SignUpCustomerAI.vue?vue&type=template&id=597caeba&"
import script from "./SignUpCustomerAI.vue?vue&type=script&lang=js&"
export * from "./SignUpCustomerAI.vue?vue&type=script&lang=js&"
import style0 from "./SignUpCustomerAI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports